<template>
  <a-select
    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
    :value="value"
    class="select"
    :disabled="!portfolio"
    placeholder="Seleccionar formulario"
    @update:value="handleChange"
  >
    <a-select-option v-for="form in forms" :key="form?.id">
      {{ form?.name }}
    </a-select-option>
  </a-select>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue";

import { Form } from "@/@types/entities/forms";
import { formService } from "@/app/entities/services";

const props = defineProps<{
  value?: number;
  portfolio?: number;
}>();

const emit = defineEmits<{
  (e: "update:value", value: number): void;
  (e: "finishLoading"): void;
}>();

const forms = ref<Form[]>([]);

const fetchForms = async () => {
  if (!props.portfolio) return;

  const response = await formService.getByPortfolio({ portfolioId: props.portfolio });

  forms.value = response;
  emit("finishLoading");
};

const handleChange = (newValue: number) => emit("update:value", newValue);

onMounted(() => fetchForms());

watch(
  () => props.portfolio,
  () => fetchForms()
);
</script>

<style lang="sass" scoped>
.select
  width: 100%
</style>
